import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SharedService} from "../../shared/shared.service";
import {SettingsCashregService} from "./settings-cashreg.service";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {PageSubheaderBarConfig} from "../../../fw/pages/page-config-api";
import {Subscription} from "rxjs/Subscription";
import {DtoCureCredit} from "./models/DtoCureCredit";
import {DtoTreatmentForCombi} from "./models/DtoTreatmentForCombi";
import {CurecreditTreatmentSearchComponent} from "./curecredit-treatment-search.component";
import {DtoArticleBaseItems} from "./models/DtoArticleBaseItems";

@Component({
    selector: 'curecredit',
    template: require('./curecredit.component.html'),
    styles: [require('./curecredit.component.css')]
})
@AutoUnsubscribe()

export class CurecreditComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    @ViewChild('gridUseTreatments', {static: false}) gridUseTreatments: DynamicGridComponent;
    busy: Subscription;
    form: FormGroup;
    dtoObject: DtoCureCredit;
    baseItems: DtoArticleBaseItems;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    useTreatmentsConfig: PageSubheaderBarConfig = {
        title: 'BEHANDELINGEN',
        buttonDefinition: [
            {
                description: 'TOEVOEGEN',
                isSmall: true,
                clickEventType: 'create'
            },
            {
                description: 'VERWIJDEREN',
                isSmall: true,
                clickEventType: 'delete'
            }
        ]
    };
    useTreatmentsColumnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Volgnummer',
            type: 'string',
            width: '140px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService,
                private dialogService: DialogService) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired]],
            index: [null,[SharedValidators.customRequired]],
            isActive: null,
            creditAmount: [null, [SharedValidators.customNumberRequired]],
            departmentId: [null, [SharedValidators.customRequired]],
            discountAmount: null,
            discountBtwId: [null, [this.validateDiscountBtw.bind(this)]],
            cashregGroupId: null,
            cashregSubGroupId: null,
            employeeAdvice: null,
            variablePrice: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getCureCreditById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.getBaseItems();
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                    this.gridUseTreatments.showData(this.dtoObject.cureCreditUseTreatments);
                });
        }
        else {
            this.ds.getCureCreditNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        index: res,
                        isActive: true,
                        creditAmount: 0,
                        variablePrice: true,
                        cureCreditUseTreatments: []
                    };
                    this.getBaseItems();

                    if (this.copyFromId > 0) {
                        this.ds.getCureCreditById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.discountBtwId = response.discountBtwId;
                                this.dtoObject.discountAmount = response.discountAmount;
                                this.dtoObject.creditAmount = response.creditAmount;
                                this.dtoObject.cashregGroupId = response.cashregGroupId;
                                this.dtoObject.cashregSubGroupId = response.cashregSubGroupId;
                                this.dtoObject.customerAdvice = response.customerAdvice;
                                this.dtoObject.departmentId = response.departmentId;
                                this.dtoObject.description = response.description;
                                this.dtoObject.isActive = response.isActive;
                                this.dtoObject.grootboekNumber = response.grootboekNumber;
                                this.dtoObject.variablePrice = response.variablePrice;

                                for(let i = 0; i < response.cureCreditUseTreatments.length; i++) {
                                    this.dtoObject.cureCreditUseTreatments.push({
                                        id: 0,
                                        index: response.cureCreditUseTreatments[i].index,
                                        treatmentId: response.cureCreditUseTreatments[i].treatmentId,
                                        description: response.cureCreditUseTreatments[i].description
                                    });
                                }

                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                                this.gridUseTreatments.showData(this.dtoObject.cureCreditUseTreatments);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getBaseItems() {
        this.ds.getArticleBaseItems(false).subscribe(response => {
            this.baseItems = response;
            if (this.dtoObject && this.dtoObject.id == 0) {
                if (this.baseItems.departments.length == 1) {
                    this.dtoObject.departmentId = this.baseItems.departments[0].id;
                }
            }
        });
    }

    getCashregSubGroups() {
        if (this.baseItems && this.form.get('cashregGroupId').value) {
            return this.baseItems.cashregGroups.find(x => x.id == this.form.get('cashregGroupId').value).cashregSubGroups;
        }
        return null;
    }

    btnUseTreatmentsBarClicked(event) {
        if (event == 'create') {
            this.showCureCreditTreatmentSearchWindow();
        } else if (event == 'delete' && this.gridUseTreatments.getSelectedItem()) {
            this.dtoObject.cureCreditUseTreatments.splice(this.dtoObject.cureCreditUseTreatments.indexOf(this.gridUseTreatments.getSelectedItem()), 1);
            this.gridUseTreatments.showData(this.dtoObject.cureCreditUseTreatments);
        }
    }

    showCureCreditTreatmentSearchWindow() {
        const dialogRef = this.dialogService.open({
            content: CurecreditTreatmentSearchComponent
        });

        const dialogContent: CurecreditTreatmentSearchComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;

        dialogContent.treatmentChosen.subscribe((res: DtoTreatmentForCombi) => {
            if (res.index > 0) {
                let currentIndex = this.dtoObject.cureCreditUseTreatments.findIndex(x => x.index == res.index);
                if (!this.dtoObject.cureCreditUseTreatments[currentIndex]) {
                    this.dtoObject.cureCreditUseTreatments.push({
                        id: 0,
                        index: res.index,
                        description: res.description,
                        treatmentId: res.id
                    });
                }
            }
            this.gridUseTreatments.showData(this.dtoObject.cureCreditUseTreatments);
        });
    }

    validateDiscountBtw(control: AbstractControl) {
        if (this.form != null && control.dirty) {
            if (this.form.value.discountAmount > 0 && !control.value)
                return {customRequired: true};
        }

        return null;
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.busy = this.ds.saveCureCredit(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/curecredit.component.ts